import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { selectors } from 'app-webtech-core';
import { VOD_SAVE_LAST_POSITION } from './types';

const podTrackerVodSaveLastPositionAction = actionCreator(VOD_SAVE_LAST_POSITION);

export const podTrackerVodSaveLastPositionThunkAction = (payload) => async (dispatch, getState) => {
  const {
    vodLastPosition,
    continueWatching: currentContinueWatching = [],
  } = selectors.podTrackerAds.properties(getState());
  const { vodContentId, position, vodSeriesId, vodEpisodeDuration } = payload;
  let continueWatching = [];
  if (vodSeriesId) {
    const val = [vodContentId, position, vodEpisodeDuration];
    if (vodLastPosition[vodSeriesId]) {
      vodLastPosition[vodSeriesId] = [
        val,
        ...vodLastPosition[vodSeriesId].filter(([episodeId]) => episodeId !== vodContentId),
      ];
    } else {
      vodLastPosition[vodSeriesId] = [val];
    }
    continueWatching = [
      vodSeriesId,
      ...currentContinueWatching.filter((contentId) => contentId !== vodSeriesId),
    ];
  } else {
    vodLastPosition[vodContentId] = position;
    continueWatching = [
      vodContentId,
      ...currentContinueWatching.filter((contentId) => contentId !== vodContentId),
    ];
  }
  dispatch(podTrackerVodSaveLastPositionAction({ vodLastPosition, continueWatching }));
};
